import { marked } from "marked";
import { useMemo } from "react";
import { sanitizeRichHtml } from "@/src/common/utils/sanitize-rich-html.utils";

interface MarkdownPreviewProps {
	source: string | null | undefined;
	className?: string;
}

export function MarkdownPreview({ source, className }: MarkdownPreviewProps) {
	const html = useMemo(() => {
		if (!source) return "";
		const rendered = marked.parse(source, { async: false });
		return sanitizeRichHtml(rendered);
	}, [source]);

	if (!source) return null;

	return (
		<article
			className={className ?? "prose prose-neutral max-w-none dark:prose-invert"}
			// biome-ignore lint/security/noDangerouslySetInnerHtml: html is sanitized via DOMPurify above
			dangerouslySetInnerHTML={{ __html: html }}
		/>
	);
}
